const modules = import.meta.glob(
    "@/assets/images/projects/project-*.*",
    {
      eager: true,
      import: "default",
    }
) as Record<string, string>;

export const getProjectImage = (projectId: number): string => {
  const base = `/src/assets/images/projects/project-${projectId}`;

  return (
      modules[`${base}.jpg`] ||
      modules[`${base}.png`] ||
      modules[`${base}.jpeg`] ||
      modules["/src/assets/images/projects/project-0.jpg"] ||
      modules["/src/assets/images/projects/project-0.png"] ||
      ""
  );
};